module.exports = __webpack_public_path__ + "static/media/icon-success.a3f97caf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-success.svg
// module id = 1473
// module chunks = 0